export interface OrderCaptureDistributor {
  id: string;
  name: string;
  is_self?: boolean;
}

/** Match M. Eye / M.Eye / m.eye — requires the dot so names like Homeyer do not pin. */
export function isMEyeDistributorName(name: string): boolean {
  return /m\.\s*eye/i.test(name);
}

export function sortDistributorsForOrderCapture<T extends OrderCaptureDistributor>(
  list: T[]
): T[] {
  const self = list.filter((d) => d.is_self === true);
  const rest = list.filter((d) => d.is_self !== true);
  const eye = rest
    .filter((d) => isMEyeDistributorName(d.name))
    .sort((a, b) => a.name.localeCompare(b.name, 'de'));
  const others = rest
    .filter((d) => !isMEyeDistributorName(d.name))
    .sort((a, b) => a.name.localeCompare(b.name, 'de'));
  return [...self, ...eye, ...others];
}

export function defaultOrderDistributorId<T extends OrderCaptureDistributor>(
  list: T[]
): string {
  const sorted = sortDistributorsForOrderCapture(list);
  const self = sorted.find((d) => d.is_self === true);
  if (self) return self.id;
  const eye = sorted.find((d) => isMEyeDistributorName(d.name));
  if (eye) return eye.id;
  return sorted[0]?.id ?? '';
}
